import { dayjs } from '@shared/utils';
import { useSyncExternalStore } from 'react';

import { serverTimeStore } from './server-time-store';

/**
 * Subscribe to the server time offset (server - client in ms).
 * Re-renders only when the offset changes (i.e. on sync, not every second).
 */
export function useServerTimeOffset(): {
  timeOffset: number;
  loading: boolean;
  getNow: () => Date;
  isLoaded: boolean;
} {
  const { timeOffset, isSyncing: loading } = useSyncExternalStore(
    serverTimeStore.subscribe,
    serverTimeStore.getSnapshot,
  );

  const getNow = () => {
    return dayjs()
      .add(timeOffset ?? 0, 'ms')
      .toDate();
  };

  return {
    timeOffset: timeOffset ?? 0,
    loading,
    getNow,
    isLoaded: timeOffset !== null,
  };
}
